import Vue from 'vue';
import App from '@/app.vue';
// 注册CeibaUi
import CeibaUi from '@tencent/ceiba-ui';
import aegis from './aegis.js';
import store from '@tencent/ceiba-ui/store.js';

// 变量
Vue.config.productionTip = false;
Vue.config.devtools = process.env.VUE_APP_ACT_ENV !== 'production';
Vue.prototype.$isInEditor = false;

Vue.config.errorHandler = function (err, vm, info) {
  console.log(`Error: ${err.toString()}\nStack: ${err.stack}\nInfo: ${info}`);
  aegis.error(`Error: ${err.toString()}\nStack: ${err.stack}\nInfo: ${info}`);
};
Vue.prototype.$aegis = aegis;

// 注册ceiba-ui
Vue.use(CeibaUi);

// 注册页面组件
// 从node_modules里正则匹配,引入活动组件
const importAllComponents = r => r.keys().forEach((key) => {
  // 判断key中不包含plugin(如果包含plugin则为插件)
  const context = r(key);
  if (key.includes('-page')) {
    if (process.env.VUE_APP_ACT_ENV !== 'production') {
      // 非正式环境,打印注册的组件
      console.log('register page entry: ', key);
      console.log('register page', context.default);
    }
    Vue.component(context.default?.name, context.default);
  } else if (key.includes('-plugin')) {
    // 插件
    if (process.env.VUE_APP_ACT_ENV !== 'production') {
      // 非正式环境,打印注册的组件
      console.log('register plugin entry: ', key);
      console.log('register plugin', context.default);
    }
    Vue.use(context.default);
  } else {
    if (process.env.VUE_APP_ACT_ENV !== 'production') {
      // 非正式环境,打印注册的组件
      console.log('register component entry: ', key);
      console.log('register component', context.default);
    }
    Vue.component(context.default?.name, context.default);
  }
});

importAllComponents(require.context('@tencent/', true, /^\.\/ceiba-act-.*index.js/));

// 加载活动数据
const actInfo = require('./page-config.json');
const deviceMode = actInfo.channel_type === 2 ? 'pc' : 'h5';
Vue.prototype.$actInfo = CeibaUi.initActInfo(actInfo, deviceMode);
// 挂载数据上报sdk - UPProbe
CeibaUi.initReport(Vue.prototype.$actInfo);

aegis?.setConfig({
  ext1: actInfo.activity_id,
  ext2: actInfo.activity_name,
});
new Vue({
  el: '#app',
  store,
  render: h => h(App),
});
